export const POPULATE_FLEETS = "POPULATE_FLEETS";
export const SET_ACTIVE_FLEET = "SET_ACTIVE_FLEET";
export const SET_ACTIVE_VEHICLE = "SET_ACTIVE_VEHICLE";
export const PATCH_ACTIVE_VEHICLE = "PATCH_ACTIVE_VEHICLE";
export const SET_FLEET_VEHICLES = "SET_FLEET_VEHICLES";
export const SET_FLEET_VEHICLES_WITH_COMPONENTS = "SET_FLEET_VEHICLES_WITH_COMPONENTS";
export const SET_TRIPS = "SET_TRIPS";
export const SET_GEOFENCES = "SET_GEOFENCES";
export const SET_EVENTS_MAP = "SET_EVENTS_MAP";
export const SET_ACTIVE_SIM_CONFIG = "SET_ACTIVE_SIM_CONFIG";
export const SET_MIN_TIMELINE_DATE = "SET_MIN_TIMELINE_DATE";
export const SET_MAX_TIMELINE_DATE = "SET_MAX_TIMELINE_DATE";
export const SET_VEHICLE_TIMELINE_STATUSES = "SET_VEHICLE_TIMELINE_STATUSES";

export const POPULATE_RIDERS = "POPULATE_RIDERS";
export const POPULATE_RIDER_COUNT = "POPULATE_RIDER_COUNT";
export const POPULATE_RESERVATIONS = "POPULATE_RESERVATIONS";
export const POPULATE_GROUP_RESERVATIONS = "POPULATE_GROUP_RESERVATIONS";
export const POPULATE_WALLET = "POPULATE_WALLET";
export const POPULATE_WALLET_TRANSACTIONS = "POPULATE_WALLET_TRANSACTIONS";
export const POPULATE_PASS_TRANSACTIONS = "POPULATE_PASS_TRANSACTIONS";
export const POPULATE_RECEIPT = "POPULATE_RECEIPT";
export const POPULATE_GROUP_RECEIPT = "POPULATE_GROUP_RECEIPT";
export const SET_ACTIVE_RIDER = "SET_ACTIVE_RIDER";
export const SET_ACCOUNT_STATUS = "SET_ACCOUNT_STATUS";
export const SET_BAN_AND_SUSPENSION_REASON = "SET_BAN_AND_SUSPENSION_REASON";
export const SET_ACTIVE_RESERVATION = "SET_ACTIVE_RESERVATION";
export const SET_ACTIVE_GROUP_RESERVATION = "SET_ACTIVE_GROUP_RESERVATION";
export const SET_LOADING_RESERVATIONS = "SET_LOADING_RESERVATIONS";
export const POPULATE_RESERVATION_CREDITS = "POPULATE_RESERVATION_CREDITS";
export const POPULATE_CUSTOMER_COUPONS = "POPULATE_CUSTOMER_COUPONS";
export const POPULATE_RESERVATION_FLEET = "POPULATE_RESERVATION_FLEET";
export const POPULATE_ACTIVE_TRIP = "POPULATE_ACTIVE_TRIP";

export const POPULATE_OTA_VEHICLES = "POPULATE_OTA_VEHICLES";
export const POPULATE_OTA_FILTER_PARAMS = "POPULATE_OTA_FILTER_PARAMS";
export const POPULATE_SC_VERSIONS = "POPULATE_SC_VERSIONS";
export const POPULATE_MD_VERSIONS = "POPULATE_MD_VERSIONS";
export const POPULATE_BMS_VERSIONS = "POPULATE_BMS_VERSIONS";
export const POPULATE_GEOFENCE_MAP_IDS = "POPULATE_GEOFENCE_MAP_IDS";
export const POPULATE_GEOFENCE_RULE_IDS = "POPULATE_GEOFENCE_RULE_IDS";
export const POPULATE_FIRMWARE_PACKAGES = "POPULATE_FIRMWARE_PACKAGES";
export const POPULATE_GEOFENCE_PACKAGES = "POPULATE_GEOFENCE_PACKAGES";
export const POPULATE_MARKETS = "POPULATE_MARKETS";
export const POPULATE_FIRMWARE_PACKAGE_APPLICATIONS = "POPULATE_FIRMWARE_PACKAGE_APPLICATIONS";
export const POPULATE_GEOFENCE_PACKAGE_APPLICATIONS = "POPULATE_GEOFENCE_PACKAGE_APPLICATIONS";
export const POPULATE_TARGET_FIRMWARE = "POPULATE_TARGET_FIRMWARE";
export const POPULATE_TARGET_GEOFENCE = "POPULATE_TARGET_GEOFENCE";
export const POPULATE_IN_PROGRESS_FPA_COUNT = "POPULATE_IN_PROGRESS_FPA_COUNT";
export const POPULATE_IN_PROGRESS_GPA_COUNT = "POPULATE_IN_PROGRESS_GPA_COUNT";
export const POPULATE_LG69T_GNSS_VERSIONS = "POPULATE_LG69T_GNSS_VERSIONS";
export const POPULATE_LG69T_APP_VERSIONS = "POPULATE_LG69T_APP_VERSIONS";

export const POPULATE_REGISTER_API_RESPONSE = "POPULATE_REGISTER_API_RESPONSE";
export const POPULATE_MANIFEST_RESPONSE = "POPULATE_MANIFEST_RESPONSE";
export const POPULATE_SHIPPING_RESPONSE = "POPULATE_SHIPPING_RESPONSE";

export const SET_ACTIVE_RATE_PLAN = "SET_ACTIVE_RATE_PLAN";
export const SET_ACTIVE_TOAST_MESSAGES = "SET_ACTIVE_TOAST_MESSAGES";
export const SET_GENERAL_SETTINGS_FORM = "SET_GENERAL_SETTINGS_FORM";
export const SET_BILLING_SETTINGS_FORM = "SET_BILLING_SETTINGS_FORM";
export const SET_MESSAGING_SETTINGS_FORM = "SET_MESSAGING_SETTINGS_FORM";
export const SET_PASSES_SETTINGS_FORM = "SET_PASSES_SETTINGS_FORM";
export const POPULATE_PASS_OFFERS = "POPULATE_PASS_OFFERS";
export const POPULATE_PASS_OFFERS_COUNT = "POPULATE_PASS_OFFERS_COUNT";
export const POPULATE_PASS_OFFER_TYPES = "POPULATE_PASS_OFFER_TYPES";
export const SET_CREATE_PASS_OFFER_ERROR_MODAL = "SET_CREATE_PASS_OFFER_ERROR_MODAL";
export const SET_SETTINGS_INVALIDS = "SET_SETTINGS_INVALIDS";

export const POPULATE_PROMO_CODES = "POPULATE_PROMO_CODES";
export const POPULATE_PROMO_CODES_COUNT = "POPULATE_PROMO_CODES_COUNT";
export const POPULATE_PROMO_GROUPS = "POPULATE_PROMO_GROUPS";
export const POPULATE_PROMO_GROUPS_COUNT = "POPULATE_PROMO_GROUPS_COUNT";
export const POPULATE_PROMO_CODES_BY_GROUP = "POPULATE_PROMO_CODES_BY_GROUP";
export const SET_ACTIVE_PROMO_CODE = "SET_ACTIVE_PROMO_CODE";
export const SET_ACTIVE_PROMO_GROUP = "SET_ACTIVE_PROMO_GROUP";

export const SET_SORT_BY = "SET_SORT_BY";
export const SET_ORDER_BY = "SET_ORDER_BY";
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_ROWS_PER_PAGE = "SET_ROWS_PER_PAGE";
export const SET_HIDE_DISABLED = "SET_HIDE_DISABLED";

export const SET_GEOFENCES_NAME = "SET_GEOFENCES_NAME";
export const SET_GEOFENCES_VISIBILITY_OPTIONS = "SET_GEOFENCES_VISIBILITY_OPTIONS";
export const SET_GEOFENCES_SIDEWALKS_EDIT_MODE = "SET_GEOFENCES_SIDEWALKS_EDIT_MODE";
export const ADD_GEOFENCES_LAYER = "ADD_GEOFENCES_LAYER";
export const SET_GEOFENCES_LAYERS = "SET_GEOFENCES_LAYERS";
export const SET_GEOFENCES_SELECTED_LAYER = "SET_GEOFENCES_SELECTED_LAYER";
export const SET_GEOFENCES_SELECTED_ZONE = "SET_GEOFENCES_SELECTED_ZONE";
export const SET_SCHEDULED_RULES = "SET_SCHEDULED_RULES";
export const INIT_GEOFENCES_DATA = "INIT_GEOFENCES_DATA";
export const SET_GEOFENCES_ERROR = "SET_GEOFENCES_ERROR";
export const SET_GEOFENCES_KEY = "SET_GEOFENCES_KEY";
export const POPULATE_ACTIVE_PASS = "POPULATE_ACTIVE_PASS";
export const DELETE_SCHEDULE_RULE = "DELETE_SCHEDULE_RULE";

export const POPULATE_USER_DEVICES = "POPULATE_USER_DEVICES ";

export const POPULATE_VEHICLES = "POPULATE_VEHICLES";
export const POPULATE_VEHICLE_COUNT = "POPULATE_VEHICLE_COUNT";
export const POPULATE_VEHICLE_SEARCH_PARAMS = "POPULATE_VEHICLE_SEARCH_PARAMS";

export const SET_GEOFENCE_PACKAGES = "SET_GEOFENCE_PACKAGES";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_IN_PROGRESS_PACKAGE = "SET_IN_PROGRESS_PACKAGE";
export const SET_PACKAGE_STATUS = "SET_PACKAGE_STATUS";
export const SET_POLLER = "SET_POLLER";
export const SET_FINAL_PACKAGE = "SET_FINAL_PACKAGE";
export const SET_FILE_CONTENT = "SET_FILE_CONTENT";
export const SET_PACKAGE_CREATION_ERROR = "SET_PACKAGE_CREATION_ERROR";
export const RESET_PACKAGE_CREATION_FLOW = "RESET_PACKAGE_CREATION_FLOW";
export const SET_GEOFENCE_PACKAGE_SIZE = "SET_GEOFENCE_PACKAGE_SIZE";

export const POPULATE_FINE_TYPES = "POPULATE_FINE_TYPES";
